/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierType } from '../model';
// @ts-ignore
import type { ContainerBlockInfoDto } from '../model';
// @ts-ignore
import type { ContainerHeight } from '../model';
// @ts-ignore
import type { ContainerStatus } from '../model';
// @ts-ignore
import type { ContainerType } from '../model';
// @ts-ignore
import type { CreateYardBlockDto } from '../model';
// @ts-ignore
import type { SlotDto } from '../model';
// @ts-ignore
import type { UnitType } from '../model';
// @ts-ignore
import type { UpdateYardBlockDto } from '../model';
// @ts-ignore
import type { YardBlockDetailsDto } from '../model';
// @ts-ignore
import type { YardBlockDto } from '../model';
// @ts-ignore
import type { YardBlockInconsistencyDto } from '../model';
// @ts-ignore
import type { YardBlockInformationDto } from '../model';
// @ts-ignore
import type { YardInconsistencyDto } from '../model';
// @ts-ignore
import type { YardSummaryDto } from '../model';
/**
 * YardBlocksApi - axios parameter creator
 */
export const YardBlocksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateYardBlockDto} [createYardBlockDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksCreate: async (createYardBlockDto?: CreateYardBlockDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardBlockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksDelete: async (yardBlockId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockId !== undefined) {
                localVarQueryParameter['yardBlockId'] = yardBlockId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('yardBlocksGet', 'id', id)
            const localVarPath = `/storage/api/YardBlocks/Get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetBlockInconsistencies: async (yardBlockId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetBlockInconsistencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockId !== undefined) {
                localVarQueryParameter['yardBlockId'] = yardBlockId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetContainersBlockNames: async (containerNumbers?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetContainersBlockNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumbers) {
                localVarQueryParameter['ContainerNumbers'] = containerNumbers;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardBlockDetails: async (containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetYardBlockDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerOrReferenceNumber !== undefined) {
                localVarQueryParameter['ContainerOrReferenceNumber'] = containerOrReferenceNumber;
            }

            if (inboundCarrierType !== undefined) {
                localVarQueryParameter['InboundCarrierType'] = inboundCarrierType;
            }

            if (outboundCarrierType !== undefined) {
                localVarQueryParameter['OutboundCarrierType'] = outboundCarrierType;
            }

            if (inboundCarrier !== undefined) {
                localVarQueryParameter['InboundCarrier'] = inboundCarrier;
            }

            if (outboundCarrier !== undefined) {
                localVarQueryParameter['OutboundCarrier'] = outboundCarrier;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (containerIsoCode !== undefined) {
                localVarQueryParameter['ContainerIsoCode'] = containerIsoCode;
            }

            if (typeCode !== undefined) {
                localVarQueryParameter['TypeCode'] = typeCode;
            }

            if (portOfLoading !== undefined) {
                localVarQueryParameter['PortOfLoading'] = portOfLoading;
            }

            if (portOfDischarge !== undefined) {
                localVarQueryParameter['PortOfDischarge'] = portOfDischarge;
            }

            if (weightClasses) {
                localVarQueryParameter['WeightClasses'] = weightClasses;
            }

            if (isReefer !== undefined) {
                localVarQueryParameter['IsReefer'] = isReefer;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            if (isRestow !== undefined) {
                localVarQueryParameter['IsRestow'] = isRestow;
            }

            if (containerOperator !== undefined) {
                localVarQueryParameter['ContainerOperator'] = containerOperator;
            }

            if (consignee !== undefined) {
                localVarQueryParameter['Consignee'] = consignee;
            }

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (locationStatus !== undefined) {
                localVarQueryParameter['LocationStatus'] = locationStatus;
            }

            if (containerType !== undefined) {
                localVarQueryParameter['ContainerType'] = containerType;
            }

            if (containerHeight !== undefined) {
                localVarQueryParameter['ContainerHeight'] = containerHeight;
            }

            if (isInTerminal !== undefined) {
                localVarQueryParameter['isInTerminal'] = isInTerminal;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (containerUnitType) {
                localVarQueryParameter['ContainerUnitType'] = containerUnitType;
            }

            if (isOOG !== undefined) {
                localVarQueryParameter['IsOOG'] = isOOG;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardBlockSummaries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetYardBlockSummaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardBlockSummary: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetYardBlockSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardInconsistencies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/GetYardInconsistencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksIsUnique: async (name?: string, id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/IsUnique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {number} [fromTier] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksSetLockStatus: async (yardBlockId?: string, fromTier?: number, lockStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/SetLockStatus/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockId !== undefined) {
                localVarQueryParameter['yardBlockId'] = yardBlockId;
            }

            if (fromTier !== undefined) {
                localVarQueryParameter['fromTier'] = fromTier;
            }

            if (lockStatus !== undefined) {
                localVarQueryParameter['lockStatus'] = lockStatus;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateYardBlockDto} [updateYardBlockDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksUpdate: async (updateYardBlockDto?: UpdateYardBlockDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlocks/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateYardBlockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlocksApi - functional programming interface
 */
export const YardBlocksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlocksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateYardBlockDto} [createYardBlockDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksCreate(createYardBlockDto?: CreateYardBlockDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksCreate(createYardBlockDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksDelete(yardBlockId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksDelete(yardBlockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetBlockInconsistencies(yardBlockId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockInconsistencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetBlockInconsistencies(yardBlockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetBlockInconsistencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetContainersBlockNames(containerNumbers?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerBlockInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetContainersBlockNames(containerNumbers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetContainersBlockNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetYardBlockDetails(containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetYardBlockDetails(containerOrReferenceNumber, inboundCarrierType, outboundCarrierType, inboundCarrier, outboundCarrier, isEmpty, size, containerIsoCode, typeCode, portOfLoading, portOfDischarge, weightClasses, isReefer, isDamaged, imoClasses, isRestow, containerOperator, consignee, isDangerous, locationStatus, containerType, containerHeight, isInTerminal, customerId, containerUnitType, isOOG, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetYardBlockDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetYardBlockSummaries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockInformationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetYardBlockSummaries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetYardBlockSummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetYardBlockSummary(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockInformationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetYardBlockSummary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetYardBlockSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksGetYardInconsistencies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardInconsistencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksGetYardInconsistencies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksGetYardInconsistencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksIsUnique(name?: string, id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksIsUnique(name, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksIsUnique']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {number} [fromTier] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksSetLockStatus(yardBlockId?: string, fromTier?: number, lockStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksSetLockStatus(yardBlockId, fromTier, lockStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksSetLockStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateYardBlockDto} [updateYardBlockDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlocksUpdate(updateYardBlockDto?: UpdateYardBlockDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlocksUpdate(updateYardBlockDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlocksApi.yardBlocksUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlocksApi - factory interface
 */
export const YardBlocksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlocksApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlocksApiYardBlocksCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksCreate(requestParameters: YardBlocksApiYardBlocksCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockDto> {
            return localVarFp.yardBlocksCreate(requestParameters.createYardBlockDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksDelete(requestParameters: YardBlocksApiYardBlocksDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.yardBlocksDelete(requestParameters.yardBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGet(requestParameters: YardBlocksApiYardBlocksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockDto> {
            return localVarFp.yardBlocksGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockDto>> {
            return localVarFp.yardBlocksGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksGetBlockInconsistenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetBlockInconsistencies(requestParameters: YardBlocksApiYardBlocksGetBlockInconsistenciesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockInconsistencyDto>> {
            return localVarFp.yardBlocksGetBlockInconsistencies(requestParameters.yardBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksGetContainersBlockNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetContainersBlockNames(requestParameters: YardBlocksApiYardBlocksGetContainersBlockNamesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerBlockInfoDto>> {
            return localVarFp.yardBlocksGetContainersBlockNames(requestParameters.containerNumbers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetSummary(options?: RawAxiosRequestConfig): AxiosPromise<YardSummaryDto> {
            return localVarFp.yardBlocksGetSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksGetYardBlockDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardBlockDetails(requestParameters: YardBlocksApiYardBlocksGetYardBlockDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockDetailsDto>> {
            return localVarFp.yardBlocksGetYardBlockDetails(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardBlockSummaries(options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockInformationDto>> {
            return localVarFp.yardBlocksGetYardBlockSummaries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksGetYardBlockSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardBlockSummary(requestParameters: YardBlocksApiYardBlocksGetYardBlockSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockInformationDto> {
            return localVarFp.yardBlocksGetYardBlockSummary(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksGetYardInconsistencies(options?: RawAxiosRequestConfig): AxiosPromise<Array<YardInconsistencyDto>> {
            return localVarFp.yardBlocksGetYardInconsistencies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksIsUniqueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksIsUnique(requestParameters: YardBlocksApiYardBlocksIsUniqueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.yardBlocksIsUnique(requestParameters.name, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksSetLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksSetLockStatus(requestParameters: YardBlocksApiYardBlocksSetLockStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlotDto>> {
            return localVarFp.yardBlocksSetLockStatus(requestParameters.yardBlockId, requestParameters.fromTier, requestParameters.lockStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlocksApiYardBlocksUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlocksUpdate(requestParameters: YardBlocksApiYardBlocksUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockDto> {
            return localVarFp.yardBlocksUpdate(requestParameters.updateYardBlockDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlocksCreate operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksCreateRequest {
    readonly createYardBlockDto?: CreateYardBlockDto
}

/**
 * Request parameters for yardBlocksDelete operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksDeleteRequest {
    readonly yardBlockId?: string
}

/**
 * Request parameters for yardBlocksGet operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksGetRequest {
    readonly id: string
}

/**
 * Request parameters for yardBlocksGetBlockInconsistencies operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksGetBlockInconsistenciesRequest {
    readonly yardBlockId?: string
}

/**
 * Request parameters for yardBlocksGetContainersBlockNames operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksGetContainersBlockNamesRequest {
    readonly containerNumbers?: Array<string>
}

/**
 * Request parameters for yardBlocksGetYardBlockDetails operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksGetYardBlockDetailsRequest {
    readonly containerOrReferenceNumber?: string

    readonly inboundCarrierType?: CarrierType

    readonly outboundCarrierType?: CarrierType

    readonly inboundCarrier?: number

    readonly outboundCarrier?: number

    readonly isEmpty?: boolean

    readonly size?: number

    readonly containerIsoCode?: string

    readonly typeCode?: string

    readonly portOfLoading?: string

    readonly portOfDischarge?: string

    readonly weightClasses?: Array<string>

    readonly isReefer?: boolean

    readonly isDamaged?: boolean

    readonly imoClasses?: Array<string>

    readonly isRestow?: boolean

    readonly containerOperator?: string

    readonly consignee?: string

    readonly isDangerous?: boolean

    readonly locationStatus?: ContainerStatus

    readonly containerType?: ContainerType

    readonly containerHeight?: ContainerHeight

    readonly isInTerminal?: boolean

    readonly customerId?: number

    readonly containerUnitType?: Array<UnitType>

    readonly isOOG?: boolean
}

/**
 * Request parameters for yardBlocksGetYardBlockSummary operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksGetYardBlockSummaryRequest {
    readonly id?: string
}

/**
 * Request parameters for yardBlocksIsUnique operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksIsUniqueRequest {
    readonly name?: string

    readonly id?: string
}

/**
 * Request parameters for yardBlocksSetLockStatus operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksSetLockStatusRequest {
    readonly yardBlockId?: string

    readonly fromTier?: number

    readonly lockStatus?: boolean
}

/**
 * Request parameters for yardBlocksUpdate operation in YardBlocksApi.
 */
export interface YardBlocksApiYardBlocksUpdateRequest {
    readonly updateYardBlockDto?: UpdateYardBlockDto
}

/**
 * YardBlocksApi - object-oriented interface
 */
export class YardBlocksApi extends BaseAPI {
    /**
     * 
     * @param {YardBlocksApiYardBlocksCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksCreate(requestParameters: YardBlocksApiYardBlocksCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksCreate(requestParameters.createYardBlockDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksDelete(requestParameters: YardBlocksApiYardBlocksDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksDelete(requestParameters.yardBlockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGet(requestParameters: YardBlocksApiYardBlocksGetRequest, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetAll(options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksGetBlockInconsistenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetBlockInconsistencies(requestParameters: YardBlocksApiYardBlocksGetBlockInconsistenciesRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetBlockInconsistencies(requestParameters.yardBlockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksGetContainersBlockNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetContainersBlockNames(requestParameters: YardBlocksApiYardBlocksGetContainersBlockNamesRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetContainersBlockNames(requestParameters.containerNumbers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetSummary(options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksGetYardBlockDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetYardBlockDetails(requestParameters: YardBlocksApiYardBlocksGetYardBlockDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetYardBlockDetails(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetYardBlockSummaries(options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetYardBlockSummaries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksGetYardBlockSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetYardBlockSummary(requestParameters: YardBlocksApiYardBlocksGetYardBlockSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetYardBlockSummary(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksGetYardInconsistencies(options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksGetYardInconsistencies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksIsUniqueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksIsUnique(requestParameters: YardBlocksApiYardBlocksIsUniqueRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksIsUnique(requestParameters.name, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksSetLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksSetLockStatus(requestParameters: YardBlocksApiYardBlocksSetLockStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksSetLockStatus(requestParameters.yardBlockId, requestParameters.fromTier, requestParameters.lockStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlocksApiYardBlocksUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlocksUpdate(requestParameters: YardBlocksApiYardBlocksUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlocksApiFp(this.configuration).yardBlocksUpdate(requestParameters.updateYardBlockDto, options).then((request) => request(this.axios, this.basePath));
    }
}

